import { submitCreativeRequest, UserFormData } from "@/api/creative";
import { Navbar } from "@/components/navbar";
import { MultiStepForm } from "@/components/ui/multi-step-form";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

export const Route = createFileRoute("/get-started")({
  component: RouteComponent,
  validateSearch: z.object({
    type: z.string().optional(),
  }),
});

function RouteComponent() {
  // const navigate = useNavigate();
  const { type } = Route.useSearch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: UserFormData) => {
    // console.log("🚀 ~ handleSubmit ~ data:", data);
    try {
      setIsSubmitting(true);
      const fromEmail = data.email;
      const toEmail = "creative@profitwheel.com";

      const submissionData: UserFormData = {
        ...data,
        from_mail: fromEmail,
        to_mail: toEmail,
      };
      await submitCreativeRequest(submissionData);
      console.log("Form submitted:", submissionData);

      // const checkoutSession = await createCheckoutSession(submissionData);
      // console.log("🚀 ~ handleSubmit ~ checkoutSession:", checkoutSession);
      // navigate({ to: "/thank-you", search: { email: fromEmail } });
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mx-auto p-6 sm:p-10 mt-12 ">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-balance">
            Where Should We Send Your Assessment?{" "}
          </h1>
          <p className="text-muted-foreground mb-8">
            Please provide your contact details so we can deliver your creative
            evaluation results directly to you once the analysis is complete.
          </p>
          <MultiStepForm
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            type={type}
          />
          <p className="text-sm text-gray-500 text-center mt-8">
            Have questions?{" "}
            <a
              href="mailto:creative@profitwheel.com?subject=creative%20query"
              className="text-purple-500 font-medium hover:underline"
            >
              Contact our support team
            </a>
          </p>

          {/* <X
            className="absolute top-5 right-5 sm:top-10 sm:right-10"
            size={24}
            onClick={() => navigate({ to: "/" })}
          /> */}
        </div>
      </div>
    </>
  );
}
